import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import '@/utils/monitor-err';
import Vue from 'vue';
import App from './App';
import Drip from './drip';
import router from './router';
import store from './store';
import { isProd } from '@/config/';
import { mtguardInit } from './utils/mtguard'; // 全局注册

Vue.use(_Dialog);

if (!isProd) {
  require('@/utils/vconsole/');
}

Vue.config.productionTip = false;

require('@/common/axios.config'); // 主入口


var main = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([Drip.ready()]);

          case 2:
            mtguardInit();
            Drip.getUuid(); // if ( process.env.NODE_ENV === 'development' ) require( 'mocks' ).default.start()

            /* eslint-disable no-new */

            new Vue({
              el: '#app',
              router: router,
              store: store,
              template: '<App/>',
              components: {
                App: App
              }
            });

          /* eslint-enable no-new */

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function main() {
    return _ref.apply(this, arguments);
  };
}();

main();